import React from 'react';
import { CARD_LABELS } from '../constants';
import { formatPrice } from "../../../util/formatPrice";

export const GradPackageCard = ({
    activePkgIdx,
    fromGradPackages,
    index,
    onCustomizeClick,
    onPkgCardClick,
    pkgProduct,
    showOwerviewPopup,
}) => {

    const priceValue = pkgProduct[fromGradPackages ? 'packagePrice' : 'retailPrice']
    const savePrice = formatPrice(pkgProduct?.packageDiscountAmount, pkgProduct?.currencyCode)
    const price = formatPrice(priceValue, pkgProduct?.currencyCode)

    const handlePkgCardClick = () => onPkgCardClick(index)
    const handleCustomizeClick = () => onCustomizeClick(pkgProduct)
    const handleShowOwerviewPopup = (event) => showOwerviewPopup(event)

    return (
        <div
            className={`grad-package-card pkg-color-${index > 3 ? 3 : index} ${activePkgIdx === index ? 'active' : ''}`}
            onClick={handlePkgCardClick}
        >
            <div className='title'>{pkgProduct?.displayName}</div>
            <div className='price-row'>
                <span className='price'>{price}</span>
                <div className='label-container'>
                    {((fromGradPackages && pkgProduct?.mostPopular) || index === 0) && <span className='best-label'>{CARD_LABELS.MOST_POPULAR}</span>}
                    {pkgProduct?.freeShipping && <span className='best-label'>{CARD_LABELS.FREE_SHIPPING}</span>}
                </div>
            </div>
            <div className='rep-message my-2'>{pkgProduct?.repMessage}</div>
            <div className='action-buttons'>
                <div
                    className='btn btn-primary btn-sm'
                    onClick={handleCustomizeClick}
                >
                    {CARD_LABELS.CUSTOMIZE}
                </div>
                {fromGradPackages && savePrice && (
                    <div
                        style={{ marginTop: '10px' }}
                        className='price-row'
                    >
                        {CARD_LABELS.SAVE(savePrice)}
                    </div>
                )}
                <div className='see-details-link-container text-center mt-2'>
                    <a
                        className='see-details-link'
                        href='#'
                        onClick={handleShowOwerviewPopup}
                    >
                        {CARD_LABELS.DETAILS}
                    </a>
                </div>
            </div>
        </div>
    )
}